const attachment = {
  id: '544f947c-390b-4200-b599-d60b3a5bd46e',
  contentType: 'application/vnd.microsoft.card.adaptive',
  name: null,
  thumbnailUrl: null,
  contentUrl: null,
  content: JSON.stringify({
    type: 'AdaptiveCard',
    $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
    version: '1.4',
    body: [
      {
        type: 'ColumnSet',
        columns: [
          {
            type: 'Column',
            width: 2,
            items: [
              {
                type: 'TextBlock',
                text: 'Leaderboard',
                wrap: true,
                fontType: 'Default',
                size: 'Medium',
                weight: 'Bolder',
                separator: true,
                spacing: 'Medium'
              },
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: '80px',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🥇 1st',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_FIRST_NAME}}',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'auto',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_FIRST_POINTS}}',
                        wrap: true
                      }
                    ]
                  }
                ]
              },
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: '80px',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🥈 2nd',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_SECOND_NAME}}',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'auto',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_SECOND_POINTS}}',
                        wrap: true
                      }
                    ]
                  }
                ]
              },
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: '80px',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🥉 3rd',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_THIRD_NAME}}',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'auto',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_THIRD_POINTS}}',
                        wrap: true
                      }
                    ]
                  }
                ]
              },
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: '80px',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '...',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: ' ',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'auto',
                    items: [
                      {
                        type: 'TextBlock',
                        text: ' ',
                        wrap: true
                      }
                    ]
                  }
                ]
              },
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: '80px',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_POSITION}}',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{FIRST_NAME}} {{LAST_NAME}}',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'auto',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{LEADERBOARD_POINTS}} points',
                        wrap: true
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    actions: [
      {
        type: 'Action.OpenUrl',
        title: 'Go to platform',
        url: '{{PLATFORM_LINK}}'
      }
    ]
  })
};

export default {
  id: 'teams_leaderboard_individual',
  title: 'Leaderboard - Individual',
  type: 'Direct',
  description: 'Message the overall standing of the leaderboard to the participants.',
  body: {
    attachments: [ attachment ],
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_PRE_LEADERBOARD_TEXT]]</p>
        <attachment id='${attachment.id}'></attachment>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  inputs: {
    INPUT_PRE_LEADERBOARD_TEXT: {
      label: 'Text before leaderboard',
      placeholder: 'Hi All ...',
      defaultValue: '<p>Hi All,</p><p>The current standing of the leaderboard is the following</p>',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/lnw/leaderboardIndividual.js